import styled from 'styled-components';
import { InningHeader } from '../PlayFeed/PlayFeed.style';
import { SummaryPlayEventsWrapper } from '../Play/play/SummaryPlayEvents.style';

import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';

const { SM_WIDE_MIN, SM_MAX } = GDBREAKPOINTS;

export const SummaryPlayListWrapper = styled.div`
    ${InningHeader} {
        margin-top: 32px;
        margin-bottom: 24px;
        &:first-child {
            margin-top: 0px;
        }
    }
    ${SummaryPlayEventsWrapper} {
            @media (min-width: ${SM_WIDE_MIN}) and (max-width: ${SM_MAX}) {
                padding: 0 57px;
            }
    }

`;

export const EmptySummaryText = styled.div`
    font-family: var(--gameday-primary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    text-align: center;
    color: var(--gameday-summary-play-event-color);
    padding-top: 25px;
    padding-bottom: 25px;
    margin-botttom: 25px;
`;

export const EmptySummaryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const VideoButton = styled.div`
    color: var(--gameday-film-room-font);
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 120%;
    cursor: pointer;
    margin-bottom: 16px;
`;

export const VideoButtonDivider = styled.div`
    height: 1px;
    background-color: var(--gameday-divider-color);
    margin-bottom: 16px;
`;
